"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegrasReposicao = void 0;
var bson_1 = require("bson");
var RegrasReposicao = /** @class */ (function () {
    function RegrasReposicao(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.materialType, materialType = _c === void 0 ? new Array() : _c, _d = _a.loteMinimo, loteMinimo = _d === void 0 ? 0 : _d, _e = _a.category, category = _e === void 0 ? new Array() : _e, _f = _a.confeccao, confeccao = _f === void 0 ? new Array() : _f, _g = _a.material, material = _g === void 0 ? new Array() : _g;
        this._id = _id;
        this.materialType = materialType;
        this.loteMinimo = loteMinimo;
        this.category = category;
        this.confeccao = confeccao;
        this.material = material;
    }
    return RegrasReposicao;
}());
exports.RegrasReposicao = RegrasReposicao;
//# sourceMappingURL=RegrasReposicao.js.map